<script>
export default {
  name: "AnalyticEvents",
  methods: {
    // home
    trackHomeCosaFareNy() {
      this.$ga.event("home", "click", "Editoriale", 0);
    },
    trackHomeCambiaIsola() {
      this.$ga.event("home", "click", "CambiaIsola", 0);
    },
    trackHomeChiSiamo() {
      this.$ga.event("home", "click", "ChiSiamo", 0);
    },
    trackHomeAgenzie() {
      this.$ga.event("home", "click", "Agenzie", 0);
    },
    trackHomeCreaIlTuoViaggio() {
      this.$ga.event("home", "click", "GotoTab", 0);
    },
    trackHomeProductVoloHotel() {
      this.$ga.event("homeTab", "click", "TabVoloHotel", 0);
    },
    trackHomeProductTour() {
      this.$ga.event("homeTab", "click", "TabTour", 0);
    },
    trackHomeProductExperience() {
      this.$ga.event("homeTab", "click", "TabExperience", 0);
    },
    trackHomeSearchVoloHotel() {
      this.$ga.event("homeTab", "click", "CreaVoloHotel", 0);
    },
    trackHomeSearchTour() {
      this.$ga.event("homeTab", "click", "CreaTour", 0);
    },
    trackHomeSearchExperience() {
      this.$ga.event("homeTab", "click", "CreaExperience", 0);
    },
    trackHomeOfferteSpecialiAltreDate() {
      this.$ga.event("homeOfferteSpeciali", "click", "AltreDate", 0);
    },
    trackHomeOfferteSpecialiScegli() {
      this.$ga.event("homeOfferteSpeciali", "click", "Scegli", 0);
    },
    trackHomeOraPartireAltreDate() {
      this.$ga.event("homeOraPartire", "click", "AltreDate", 0);
    },
    trackHomeOraPartireScegli() {
      this.$ga.event("homeOraPartire", "click", "Scegli", 0);
    },
    trackHomeModaleTourProcedi() {
      this.$ga.event("homeModaleTour", "click", "Procedi", 0);
    },
    trackHomeModaleTourItinerario() {
      this.$ga.event("homeModaleTour", "click", "Itinerario", 0);
    },
    trackHomeModaleExperienceItinerario() {
      this.$ga.event("homeExperienceModale", "click", "Itinerario", 0);
    },
    trackResultTourModifica() {
      this.$ga.event("resultTour", "click", "Modifica", 0);
    },
    trackResultExperienceModifica() {
      this.$ga.event("resultExperience", "click", "Modifica", 0);
    },
    trackResultModaleTourProcedi() {
      this.$ga.event("resultTourModale", "click", "Procedi", 0);
    },
    trackResultModaleTourItinerario() {
      this.$ga.event("resultTourModale", "click", "Itinerario", 0);
    },
    trackResultExperienceScegli() {
      this.$ga.event("resultExperience", "click", "Scegli", 0);
    },
    trackResultModaleExperienceProcedi() {
      this.$ga.event("resultExperienceModale", "click", "Procedi", 0);
    },
    trackResultModaleExperienceItinerario() {
      this.$ga.event("resultExperienceModale", "click", "Itinerario", 0);
    },
    trackBreadcrumbVoloHotel() {
      this.$ga.event("wizardBreadcrumb", "click", "VoloHotel", 0);
    },
    trackBreadcrumbTour() {
      this.$ga.event("wizardBreadcrumb", "click", "Tour", 0);
    },
    trackBreadcrumbExperience() {
      this.$ga.event("wizardBreadcrumb", "click", "Experience", 0);
    },
    trackBreadcrumbAttivita() {
      this.$ga.event("wizardBreadcrumb", "click", "Attivita", 0);
    },
    trackBreadcrumbTrasferimenti() {
      this.$ga.event("wizardBreadcrumb", "click", "Trasferimenti", 0);
    },
    trackBreadcrumbCompleta() {
      this.$ga.event("wizardBreadcrumb", "click", "Completa", 0);
    },
    trackTabVoloAltreAlternative() {
      this.$ga.event("wizardVolo", "click", "MostraAlternative", 0);
    },
    trackTabVoloInfoVoli() {
      this.$ga.event("wizardVolo", "click", "Info", 0);
    },
    trackTabVoloSelezionaVolo() {
      this.$ga.event("wizardVolo", "click", "Cambia", 0);
    },
    trackTabTourCambiaCategoria() {
      this.$ga.event("wizardTour", "click", "CambiaCategoria", 0);
    },
    trackTabTourModificaInfo() {
      this.$ga.event("wizardTour", "click", "Info", 0);
    },
    trackModaleDettaglioTour() {
      this.$ga.event("wizardModaleTour", "click", "TabItinerario", 0);
    },
    trackTabHotelAltreAlternative() {
      this.$ga.event("wizardHotel", "click", "MostraAlternative", 0);
    },
    trackTabHotelInfo() {
      this.$ga.event("wizardHotel", "click", "Info", 0);
    },
    trackModaleListaHotelFiltroRating() {
      this.$ga.event("wizardHotelList", "click", "FiltroRating", 0);
    },
    trackModaleListaHotelSeleziona() {
      this.$ga.event("wizardHotelList", "click", "CambiaHotel", 0);
    },
    trackModaleListaHotelInfo() {
      this.$ga.event("wizardHotelList", "click", "ClickInfo", 0);
    },
    trackModaleListaHotelPrezzoMappa() {
      this.$ga.event("wizardHotelList", "click", "ClickPrezzoMappa", 0);
    },
    trackModalDettaglioHotelCambia() {
      this.$ga.event("wizardModaleHotel", "click", "CambiaHotel", 0);
    },
    trackModalDettaglioHotelChiudi() {
      this.$ga.event("wizardModaleHotel", "click", "Chiudi", 0);
    },
    trackModalDettaglioHotelTabDescrizione() {
      this.$ga.event("wizardModaleHotel", "click", "TabDescrizione", 0);
    },
    trackTabAttivitaTabBlu() {
      this.$ga.event("wizardAttivita", "click", "TabBlu", 0);
    },
    trackTabAttivitaCambiaData() {
      this.$ga.event("wizardAttivita", "click", "CambiaData", 0);
    },
    trackTabAttivitaMostraAlternative() {
      this.$ga.event("wizardAttivita", "click", "MostraAlternative", 0);
    },
    trackTabAttivitaInfo() {
      this.$ga.event("wizardAttivita", "click", "Info", 0);
    },
    trackModaleListaAttivitaFiltroData() {
      this.$ga.event("wizardAttivitaList", "click", "FiltroData", 0);
    },
    trackModaleListaAttivitaAggiungi() {
      this.$ga.event("wizardAttivitaList", "click", "Aggiungi", 0);
    },
    trackModaleListaAttivitaPrezzoMappa() {
      this.$ga.event("wizardAttivitaList", "click", "InfoMap", 0);
    },
    trackModaleListaAttivitaInfo() {
      this.$ga.event("wizardAttivitaList", "click", "Info", 0);
    },
    trackModaleListaAttivitaElimina() {
      this.$ga.event("wizardAttivitaList", "click", "Elimina", 0);
    },
    trackModaleAttivitaAggiungi() {
      this.$ga.event("wizardModaleAttivita", "click", "Aggiungi", 0);
    },
    trackModaleAttivitaTabDescrizione() {
      this.$ga.event("wizardModaleAttivita", "click", "TabDescrizione", 0);
    },
    trackTabTraferimentiTabBlu() {
      this.$ga.event("wizardTrasf", "click", "TabBlu", 0);
    },
    trackTabTraferimentiMostraAlternative() {
      this.$ga.event("wizardTrasf", "click", "MostraAlternative", 0);
    },
    trackModaleListaTrasferimentiAA() {
      this.$ga.event("wizardTrasfList", "click", "AggiungiAndata", 0);
    },
    trackModaleListaTrasferimentiRR() {
      this.$ga.event("wizardTrasfList", "click", "AggiungiRitorno", 0);
    },
    trackSidebarInfo() {
      this.$ga.event("wizardSidebar", "click", "Info", 0);
    },
    trackSidebarElimina() {
      this.$ga.event("wizardSidebar", "click", "Elimina", 0);
    },
    trackTabCompletaPreventivo() {
      this.$ga.event("wizardCompleta", "click", "Completa", 0);
    },
    trackModaleCompletaPreventivoConcludi() {
      this.$ga.event("wizardModaleCompleta", "click", "Concludi", 0);
    },
    trackModaleCompletaPreventivoAnnulla() {
      this.$ga.event("wizardModaleCompleta", "click", "Annulla", 0);
    },
    trackModaleCompletaPreventivoVisualizza() {
      this.$ga.event("wizardModaleCompleta", "click", "Visualizza", 0);
    },
    trackModaleCompletaPreventivoChiudi() {
      this.$ga.event("wizardModaleCompleta", "click", "Chiudi", 0);
    },
    trackGtmModaleCompletaPreventivoConcludi(data) {
      gtag("event", "quote", data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/common/AnalyticEvents.vue